'use strict';

module.exports = Odigeo.View.extend({
    setOF2Template() {
        this.setTemplate(this.$el, 'membershipTimeoutPopupOf2', this.widget.options);
    },
});
